import { AfterViewInit, Directive } from '@angular/core';
import { CartDetailsSourceIdsEnum } from '../../models/cartDetails/data-source-ids.enum';
import { DataLayerService } from '../../customer-actions/data-layer.service';
import SlotService from '../../cart-process/slot.service';

@Directive({
  selector: '[page-scroller-directive]',
})
export class PageScrollerDirective implements AfterViewInit {
  readonly FOCUS_BUNDLE_ITEM_NAME = 'focusedBundleNumber';

  constructor(
    private dataLayerService: DataLayerService,
    private slotService: SlotService,
  ) {}

  ngAfterViewInit(): void {
    this.scrollToBundle();

    this.dataLayerService.dataObs$.subscribe((data) => {
      if (data && data[CartDetailsSourceIdsEnum.ACCESSORY_ADD_NEW]) {
        const bundleNumber = data[CartDetailsSourceIdsEnum.ACCESSORY_ADD_NEW][0].bundleNumber;

        this.scrollTo(bundleNumber);
      }

      if (data && data[CartDetailsSourceIdsEnum.OPTIONAL_MEMBER]) {
        const slots = this.slotService.getSlots();
        const bundleNumber = slots[slots.length - 2].bundleNumber;

        this.scrollTo(bundleNumber, true);
      }
    });
  }

  private scrollToBundle(): void {
    const focusBundleNumber: string = localStorage.getItem(this.FOCUS_BUNDLE_ITEM_NAME);

    if (!focusBundleNumber) {
      return;
    }

    localStorage.removeItem(this.FOCUS_BUNDLE_ITEM_NAME);

    this.scrollTo(focusBundleNumber);
  }

  private scrollTo(bundleNumber: number | string, addHeight?: boolean): void {
    const element: HTMLElement = document.querySelector(`[data-bundle-number="${bundleNumber}"]`);

    setTimeout(() => {
      const elementToScroll: HTMLElement = document.querySelector(`[data-automation-id="member-${this.slotService.ordinalNumber}-new-number-label"]`);

      if (elementToScroll) {
        elementToScroll.focus();
      }
    }, 3500);

    if (element) {
      let topPos = element.getBoundingClientRect().top + document.documentElement.scrollTop;

      if (addHeight) {
        topPos += element.offsetHeight;
      }

      window.scroll({
        top: topPos,
        behavior: 'smooth'
      });
    }
  }
}

